<template>
  <Section narrow>
    <div v-html="props.content" />
    <Spacer size="small" />
    <FlexGrid :cols="2" align="center">
      <h3 class="no-margin">Sdílet</h3>
      <ClientOnly>
        <SocialsWidget :share-url="windowLocation" />
      </ClientOnly>
    </FlexGrid>
  </Section>

  <DynamicContentResolver v-if="blocks?.length" :blocks="blocks" />

  <Section v-if="otherPositions.length" background="blue" fullwidth>
    <Slider
      :title="$t('career.featured.title')"
      :more-label="$t('career.featured.cta')"
      :more-link="$t('career.featured.cta_link')"
      :slides="(otherPositions as any)"
      display="jobs"
    />
  </Section>
</template>

<script lang="ts" setup>
import { openJobModal } from '~/lib/modals'
import type { DynamicContentBlocksFragment, FormFragment } from '#gql'

const props = defineProps<{
  title?: string | null
  content?: string | null
  form?: FormFragment | null
  blocks?: DynamicContentBlocksFragment[]
}>()

const windowLocation = window?.location.href

const { data: careers } = await useAsyncGql('GetCareersList')

const otherPositions = careers.value?.careers.data?.length
  ? careers.value.careers.data.reduce((acc, it) => {
      it.slug && acc.push({
        title: it.title,
        tags: [it.city],
        link: '/' + it.slug, // TODO: předělat na compose podle parentů
      })
      return acc
    }, [] as any[])
  : []

</script>
